import { render, staticRenderFns } from "./MolliePaymentStart.vue?vue&type=template&id=5737de4b&scoped=true&"
import script from "./MolliePaymentStart.vue?vue&type=script&lang=js&"
export * from "./MolliePaymentStart.vue?vue&type=script&lang=js&"
import style0 from "./MolliePaymentStart.vue?vue&type=style&index=0&id=5737de4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5737de4b",
  null
  
)

export default component.exports